// Opens the share wizard on a hike's Trail Trailer — the "Hike trailer" option in a hike's share
// options (the hike page's More menu, a hikes-list row's menu). The hike's 3D preview no longer offers
// it: the trailer is an overview of the whole hike, so it lives with the hike's other share options.

import { RevenueCatWrapper } from '../../utils/RevenueCatWrapper';
import { OnBoardingGoal } from '../../utils/models/OnBoardingGoal';
import { flyoverShareStyleUrl } from './flyoverShareStyle';
import { hikeTrailerShareConfig, type HikeForTrailerShare } from './trailerShare';
import type { ShareSource } from './shareAnalytics';

type WizardWindow = Window & {
  showFlyoverShare?: (cfg: unknown) => void;
  onBoardingVue?: { launchFor?: (goal: unknown) => void };
};

export async function openHikeTrailerShare(
  hike: HikeForTrailerShare | null | undefined,
  source: Extract<ShareSource, 'hike_overview' | 'hikes_list'>,
): Promise<void> {
  const win = window as WizardWindow;
  const show = win.showFlyoverShare;
  if (typeof show !== 'function') return;
  // GenerateHikeTrailer needs an account; send a signed-out visitor to sign-up rather than into a
  // wizard whose Continue button can only fail.
  if (!window.user) {
    win.onBoardingVue?.launchFor?.(OnBoardingGoal.CreateAccount);
    return;
  }
  // Render in the user's currently-selected map style, as the recording page's share option does.
  const isPro = await RevenueCatWrapper.isProOrProPlus();
  const cfg = hikeTrailerShareConfig(hike, window.location.href, flyoverShareStyleUrl(isPro));
  if (cfg) show({ ...cfg, source });
}
